export interface Address {
  street: string;
  zip: string;
  city: string;
  province: string;
  mapsQuery: string;
}

export interface Company {
  legalName: string;
  vat: string;
  rea: string;
  shareCapital: string;
  foundedYear: number;
  ateco: string;
  email: string;
  pec: string;
  website: string;
  registeredOffice: Address;
  operationalOffice: Address;
}

export const company: Company = {
  legalName: "TUXIA S.R.L.",
  vat: "05625030266",
  rea: "TV-460183",
  shareCapital: "€ 20.000,00 i.v.",
  foundedYear: 2026,
  ateco: "62.10.00",
  email: "info@tuxia.it",
  pec: "legal@pec.tuxia.it",
  website: "www.tuxia.it",
  registeredOffice: {
    street: "Via San Giovanni Bosco 28",
    zip: "31015",
    city: "Conegliano",
    province: "TV",
    mapsQuery: "Via San Giovanni Bosco 28, 31015 Conegliano TV",
  },
  operationalOffice: {
    street: "Via Bassone 163/B",
    zip: "37139",
    city: "Verona",
    province: "VR",
    mapsQuery: "Via Bassone 163/B, 37139 Verona VR",
  },
};
